module.exports = __webpack_public_path__ + "img/youjian.562b285e.svg";